import React, { useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { BsFillHouseDoorFill, BsArrowRightCircle } from 'react-icons/bs'
import { FaNotesMedical } from 'react-icons/fa'
import { MdComputer, MdSell } from 'react-icons/md'
import { RiShoppingBag3Fill } from 'react-icons/ri'
import { GiHumanTarget } from 'react-icons/gi'

import './styles.css'

export default function LandingSolution() {
    return (
        <LandingWrapper>
            <Header />
            <Service />
            <DocumentConcerned />
            <Integration />
        </LandingWrapper>
    )
}

const Header = () => {
    return (
        <React.Fragment>
            <div className="landing-solution__body-content">
                <div className="flip-header-tarif">
                    <div className="landing-solution__body-content-left-title">
                        <h1>SOLUTIONS DÉDIÉES À DES SECTEURS D'ACTIVITÉ ET SERVICES SPÉCIFIQUES</h1>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const Service = () => {
    return (
        <React.Fragment>
            <div className="landing-solution__service-content">
                <div className="landing-solution__service-top">
                    <div className="landing-solution__service-top-txt">
                        Le réseau DKB Sign permet aux entreprises de tout
                        type et de toute taille de conclure des affaires
                        plus rapidement à tout moment, en tout lieu et sur
                        tous les appareils grâce à la solution de signature
                        électronique la plus utilisée en Côte d'Ivoire. Ci-
                        dessous, vous trouverez des exemples illustrant
                        comment DKB Sign peut transformer des secteurs
                        et des services :
                    </div>
                    <img src="./assets/media/home_icon/FileInvite - Digital Signatures.png" className='landing-solution__service-img' alt="img" />
                </div>
                <div className="landing-solution__service-bottom">
                    <div className="landing-solution__service-bottom-col">
                        <div className="landing-solution__service-bottom-items">
                            <BsFillHouseDoorFill color='white' className='landing-solution__item-img' />
                            <p>Immobilier</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <FaNotesMedical color='white' className='landing-solution__item-img' />
                            <p>Assurance</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <MdComputer color='white' className='landing-solution__item-img' />
                            <p>Haute technologie</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <img src="./assets/media/home_icon/bank-solution.png" className='landing-solution__item-img' alt="bank-solution" />
                            <p>Banque</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <img src="./assets/media/home_icon/industrie-solution.png" className='landing-solution__item-img' alt="industrie-solution" />
                            <p>Industrie</p>
                        </div>
                    </div>

                    <div className="landing-solution__service-bottom-col">
                        <div className="landing-solution__service-bottom-items">
                            <MdSell color='white' className='landing-solution__item-img' />
                            <p>Ventes</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <RiShoppingBag3Fill color='white' className='landing-solution__item-img' />
                            <p>Achat</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <GiHumanTarget color='white' className='landing-solution__item-img' />
                            <p>Ressources humaines</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <img src="./assets/media/home_icon/commercial-solution.png" className='landing-solution__item-img' alt="commercial-solution" />
                            <p>Commercial</p>
                        </div>
                        <div className="landing-solution__service-bottom-items">
                            <img src="./assets/media/home_icon/marketing-solution.png" className='landing-solution__item-img' alt="marketing-solution" />
                            <p>Marketing</p>
                        </div>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}

const DocumentConcerned = () => {
    const [cards, setCards] = useState([
        {
            no: <MdSell color={'white'} size={20} />,
            title: 'Vente',
            description: 'Devis, contrats de vente, Conditions Générales de Vente...'
        },
        {
            no: <GiHumanTarget color={'white'} size={20} />,
            title: 'Ressources humaines',
            description: 'Contrats de travail, avenants, notes de frais...'
        },
        {
            no: <RiShoppingBag3Fill color={'white'} size={20} />,
            title: 'Achat Finance',
            description: 'Factures, bons de commande, accords de confidentialité...'
        }
    ])

    return (
        <React.Fragment>
            <div className="landing-solution__document-concerned-content">
                <div className="landing-solution__document-concerned-title">Quels sont les documents concernés ?</div>
                <div className="landing-solution__document-concerned-desc">
                    En ligne, a distance ou en face-a-face, la signature électronique est essentielle au processus de contractualisation.
                    Elle est aujourd'hui incontournable et s'applique a tous les de documents. <br />
                    que vous pouvez signer a la main :
                </div>
                <div className="landing-some-click-cards">
                    {cards.map((card, index) => { return <SignSomeClickCard card={card} key={index} /> })}
                </div>
            </div>
        </React.Fragment>
    )
}

const SignSomeClickCard = ({ card }) => {
    return (
        <div className="landing-some-click-card border-card-blue">
            <div className="landing-some-click-card__number">{card.no}</div>
            <div className="landing-some-click-card__content">
                <div className="landing-some-click-card__content-title">{card.title}</div>
                <div className="landing-some-click-card__content-description">{card.description}</div>
            </div>
        </div>
    )
}

const Integration = () => {
    return (
        <React.Fragment>
            <div className="landing-solution__integration-content">
                <div className="landing-solution__integration-header">
                    <h2>Intégration de DKB Sign dans vos outils d'aide a la vente</h2>
                </div>
                <div className="landing-solution__integration-bot">
                    <div className="landing-solution__integration-desc">
                        <div className="landing-solution__integration-img"><BsArrowRightCircle color={'#5858cc'} size={60} /></div>
                        <div className="landing-solution__integration-txt">
                            Comme nos connecteurs sont déjà pré
                            configurés dans les outils d'aide à la
                            vente (CRM) les plus populaires du
                            marché, l'intégration de DKB Sign se
                            fait en quelques clics. En créant tous
                            types de workflow (plus ou moins
                            complexes) adaptés à vos besoins
                            métier, les partenariats établis par
                            DKB Sign avec les acteurs
                            incontournables du marché vous
                            offrent un moyen simple et rapide
                            d'envoyer n'importe quel document à
                            n'importe quel signataire.
                        </div>
                    </div>
                    <a className="content_form-send __integration-btn" href="#">CONTACTEZ-NOUS</a>
                </div>


            </div>
        </React.Fragment>
    )
}